import { Link } from 'react-router-dom';
import { articlesMeta } from '@/mocks/articlesData';

export default function Footer() {
  return (
    <footer className="bg-background-100/80 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-semibold text-foreground-900 tracking-tight">
                Sugargoo<span className="text-primary-500">Sheet</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md mb-4">
              Your independent Sugargoo Spreadsheet resource platform. We help international shoppers discover products, understand Sugargoo services, compare costs, and shop safely.
            </p>
            <p className="text-xs text-foreground-500 italic">
              Disclaimer: Sugargoo Sheet is an independent educational resource website. We are not officially affiliated with Sugargoo or any marketplace platform.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">Shopping Guides</h4>
            <ul className="space-y-2.5">
              {articlesMeta.slice(0, 5).map((article) => (
                <li key={article.slug}>
                  <Link
                    to={`/${article.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">More Resources</h4>
            <ul className="space-y-2.5">
              {articlesMeta.slice(5).map((article) => (
                <li key={article.slug}>
                  <Link
                    to={`/${article.slug}`}
                    className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                  >
                    {article.title}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200"
                >
                  Main Website <i className="ri-arrow-right-up-line text-xs"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Sugargoo Sheet. All rights reserved. Independent educational resource.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200"
            >
              Main Site
            </a>
            <Link
              to="/sugargoo-spreadsheet-guide"
              className="text-xs text-foreground-500 hover:text-primary-500 transition-colors duration-200"
            >
              Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}